import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const BlogLayout3 = () => {
  return (
    <div>
      <Navbar />
      <div className="bg-gray-50 min-h-screen p-6">
        {/* Main Container */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Blog Content Section */}
          <div className="lg:col-span-2 bg-white shadow-md rounded-lg p-6 border border-gray-200">
            {/* Blog Title */}
            <h1 className="text-2xl font-bold text-gray-800">
              How to Connect Two Solar Panels to one Battery
            </h1>
            {/* Author Info */}
            <p className="mt-2 text-sm text-gray-600">
              December 15, 2023 by{" "}
              <span className="font-semibold text-blue-500">Nick Seghers</span>
            </p>
            <img
              src="/Assets/2-solar.webp"
              alt="Farm"
              className="w-full h-auto mt-4 rounded-md"
            />
            <p>connecting two solar panels to a battery diagram</p>
            <br />
            <p>
              Connecting two solar panels to one battery with one charge
              controller is easy. This article will explain how you do it,
              including schematics.
            </p>
            <p>First of all, you should know this:</p>
            <p className="text-orange-700">
              You cannot connect your solar panels directly to a battery.{" "}
            </p>
            <br />
            <p>
              When you connect your solar panels directly to your battery, you
              will damage the battery (lead-acid or lithium). You need a device
              that measures the state of charge of your battery and charges it
              accordingly, just like a car battery charger.
            </p>
            <p>
              The device we are going to use is called a charge controller. As
              the word says, it will control the charging of your battery.
            </p>
            <p>Purpose of a charge controller:</p>
            <ul>
              <li>Stop charging when the battery is full</li>
              <li>Adjust the charging voltage and current</li>
            </ul>
            <br />
            <p>
              use my MPPT{" "}
              <Link className="text-green-500 hover:underline" to="">
                Charge Controller Calculator
              </Link>{" "}
              to figure out what charge controller you need.
            </p>
            <br />
            <p className="text-black-700 font-semibold text-lg ">
              Step 1: Connect Your Battery to the Charge Controller
            </p>
            <p>
              When you want to connect two solar panels to one battery, you must
              first connect your battery to the charge controller. It is crucial
              that you do this step first. If you connect the solar panels to
              the charge controller, you might risk destroying the charge
              controller in the process.
            </p>
            <p>
              Wire thickness depends on your charge controller’s current to the
              batteries. For example, the{" "}
              <Link className="text-green-500 hover:underline" to="/">
                Renogy Rover 20A
              </Link>{" "}
              delivers 20 amps to the battery. You need wires that can carry at
              least 20Amps or more and use a 30A fuse on the wire. Only fuse the
              positive wire. If you use a flexible copper wire, you need{" "}
              <Link className="text-green-500 hover:underline" to="/">
                this AWG12 wire
              </Link>{" "}
              with{" "}
              <Link className="text-green-500 hover:underline" to="/">
                this fuse
              </Link>
              . Read my article about selecting the right{" "}
              <Link className="text-green-500 hover:underline" to="/">
                {" "}
                fuse
              </Link>{" "}
              and{" "}
              <Link className="text-green-500 hover:underline" to="/">
                wire
              </Link>{" "}
              size.
            </p>
            <p>
              Place the fuse as close to the battery terminals as possible. The
              manual of the charge controller will tell you what wire to use.
            </p>
            <br />
            <p>It should look like this:</p>
            <img
              src="/Assets/connecting-battery.webp"
              alt="Farm"
              className="w-full h-auto mt-4 rounded-md"
            />
            <p>Connecting the battery to the charge controller</p>
            <br />
            <p className="text-black-700 font-semibold text-lg ">
              Step 2: Connect Your Two Solar Panels Together
            </p>
            <p>In this step, you will learn how to connect two solar panels.</p>
            <p>
              This can be done in series or in parallel. I have written an
              article about the pros and cons of both of them. You can read it
              here: Series VS parallel for solar panels (opens in new tab). You
              can also check out my video about series vs parallel here. Here is
              the short version:
            </p>
            {/* Blog Content */}
            <div className="mt-4 text-gray-700 space-y-4"></div>
            <div className="bg-gray-50 p-6">
              {/* About Me Section */}
              <div className="flex items-start bg-white shadow-md rounded-lg p-4 border border-gray-200">
                {/* Profile Image */}
                <img
                  src="/Assets/pro.webp" // Replace with your actual image path
                  alt="Nick Seghers"
                  className="w-20 h-20 rounded-full object-cover mr-4"
                />
                {/* Text Content */}
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">
                    Nick Seghers
                  </h2>
                  <p className="text-gray-700 text-sm mt-2">
                    I’m an off-grid enthusiast. I created this website to give
                    clear and straight-to-the-point advice about solar power.
                    I’m also the author of the book{" "}
                    <a
                      href="https://example.com/off-grid-solar-power-simplified"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 underline"
                    >
                      Off-grid solar power simplified
                    </a>
                    .
                  </p>
                  <p className="text-gray-700 text-sm mt-2">
                    Read more about me on my{" "}
                    <Link
                      to="/aboutmesection"
                      href=""
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 underline"
                    >
                      about page
                    </Link>
                    , check out my{" "}
                    <Link
                      to="https://www.youtube.com/@odedeyidamilare"
                      href=""
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 underline"
                    >
                      Youtube channel
                    </Link>
                    , or{" "}
                    <Link
                      to="/contactsection"
                      href=""
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 underline"
                    >
                      send me a message
                    </Link>
                    .
                  </p>
                </div>
              </div>

              {/* Leave a Comment Section */}
              <div className="mt-8 bg-white shadow-md rounded-lg p-4 border border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800">
                  Leave A Comment
                </h3>

                {/* Name Input */}
                <div className="mt-4">
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    placeholder="Your name"
                    className="w-full mt-1 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                  />
                </div>

                {/* Email Input */}
                <div className="mt-4">
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Your email"
                    className="w-full mt-1 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                  />
                </div>

                {/* Website Input */}
                <div className="mt-4">
                  <label
                    htmlFor="website"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Website
                  </label>
                  <input
                    type="url"
                    id="website"
                    placeholder="Your website"
                    className="w-full mt-1 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                  />
                </div>

                {/* Save Info Checkbox */}
                <div className="mt-4 flex items-start">
                  <input
                    type="checkbox"
                    id="save-info"
                    className="h-4 w-4 text-blue-500 border-gray-300 rounded focus:ring-blue-400"
                  />
                  <label
                    htmlFor="save-info"
                    className="ml-2 text-sm text-gray-700"
                  >
                    Save my name, email, and website in this browser for the
                    next time I comment.
                  </label>
                </div>

                {/* Text Area */}
                <textarea
                  className="w-full mt-4 p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                  rows="5"
                  placeholder="Write your comment here..."
                ></textarea>

                {/* Submit Button */}
                <button className="mt-4 px-6 py-2 bg-green-700 text-white font-semibold rounded-lg hover:bg-blue-600">
                  Post Comment
                </button>
              </div>
            </div>
          </div>

          {/* About Me Sidebar */}
          <div className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
            <h2 className="text-lg font-bold text-gray-800">About Me</h2>
            <div className="mt-4 flex flex-col items-center">
              {/* Profile Image */}
              <img
                src="/Assets/man.webp" // Replace with your actual image path
                alt="Nick Seghers"
                className="w-24 h-24 rounded-full object-cover"
              />
              {/* About Content */}
              <p className="text-gray-700 text-center text-sm mt-4">
                Welcome to Solarissurge.net! I'm the driving force behind this
                site, which attracts over 1,000 daily visitors interested in
                solar energy. I'm also the author of a popular solar energy
                book, with over 80,000 copies sold and more than 2,000 reviews
                averaging 4.5 stars. My mission is to demystify solar power and
                make it accessible to everyone. Join me in exploring the
                potential of solar power to create a cleaner, brighter future!
                Link to the book on Amazon.{" "}
                <Link
                  className=" text-green-500 hover:underline"
                  to="/aboutmesection"
                >
                  Read more about me here,
                </Link>{" "}
                check out my{" "}
                <Link
                  className=" text-green-500 hover:underline"
                  to="https://www.youtube.com/@odedeyidamilare"
                >
                  Youtube channel
                </Link>
                , or{" "}
                <Link
                  className=" text-green-500 hover:underline"
                  to="/contactsection"
                >
                  send me a message.
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <a
        href="https://wa.me/+2348165213568?text=Hi!%20I%20have%20a%20query."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-green-500 p-3 rounded-full shadow-lg hover:bg-green-200"
      >
        <img
          src="/Assets/chat.png" // <-- Replace this with the actual image path or URL from Flaticon
          alt="WhatsApp Chat"
          className="w-8 h-8" // Tailwind sizes (e.g., w-6 = 24px)
        />
      </a>
      <Footer />
    </div>
  );
};

export default BlogLayout3;
